import React, { useEffect, useState } from 'react';
import { BreadCrumb } from '../../../components';
import styles from './user-access-management.module.scss';
import { Tabs } from 'antd';
import { getBreadCrumbList } from '../../../utils/helper';
import { UserAccessList } from './UserAccessList/UserAccessList';
import UserManagementDashboard from './UserManagementDashboard/UserManagementDashboard';
import { useHistory } from 'react-router-dom';

const UserAccessManagement = (props) => {
  const { tab } = props;
  const [activeTab, setActiveTab] = useState(tab);
  const history = useHistory();
  const items = [
    { label: 'User Access Management Dashboard', key: '0', children: <UserManagementDashboard /> },
    { label: 'User Access Management List', key: '1', children: <UserAccessList /> },
  ];

  useEffect(() => {
    setActiveTab(tab);
  }, [tab]);

  return (
    <div className={styles.container}>
      <BreadCrumb level={3} breadCrumbList={getBreadCrumbList([`Dashboard`, `Admin`, `User Access Management`])} />
      <div className={styles.header}>
        <div className={styles.title}>User Access Management</div>
      </div>
      <Tabs
        items={items}
        activeKey={activeTab}
        onChange={(activeKey) => {
          console.log(activeKey);
          history.push(`/admin/user-access-management/${activeKey === '0' ? 'dashboard' : 'list'}`);
        }}
        destroyInactiveTabPane={true}
      />
    </div>
  );
};

export default UserAccessManagement;
